import { flatMap } from 'lodash-es';

import { CodeSearchResult } from 'src/types/search';

export default function getMatchLineNumbers(
  result: CodeSearchResult
): number[] {
  const nonEmptyHunks = result.content_matches.filter(
    hunk => hunk && hunk.lines
  );
  return flatMap(nonEmptyHunks, hunk => hunk.lines)
    .filter(
      line =>
        line.line &&
        line.segments &&
        line.segments.some(segment => !!segment.match)
    )
    .map(line => line.line);
}
